import React, { Component } from "react";
import "../stylesheets/paymentsPageStyles.css";
import "../stylesheets/landingPageStyles.css";
import axios, { axiosLatest, axiosWC } from "../../axios";
import DescriptionComponent from "../paymentsComponents/descriptionContent";
// import PaymentProgress from '../paymentsComponents/paymentProgress';
import UpcomingBatchesComponent from "../Shared Components/upcomingBatches";
import FillDetailsComponent from "../paymentsComponents/fillDetails";
import OrderSummaryComponent from "../paymentsComponents/orderSummary";
import DoubtAssistanceComponent from "../paymentsComponents/doubtAssistance";
import { sendRequestToLogging } from "../../ErrorBoundary";
import ErrorComponent from "../../Shared Components/404";
import { gtagHelperFunction } from "../Shared Components/gtagHelperFunction";
import { getUrlSearchParams, setInitiatePayment } from "../utils";
import SalesTimer from "../salesTimer";
import { SALE_ACTIVE, SALE_END_DATE, SALE_START_DATE } from "../../urls";
import PhonePePaymentComponent from "../paymentsComponents/phonePePayment";

const exemptedThreeNinetyPromotionForCourses = new Set([
  "dsa-journey-cpp-java",
  "dsa-journey-js",
  "dsa-journey-python",
  "dsa-projects",
  "cp-journey-beg-to-adv",
  "mastering-web-scraping-with-python",
  "Getting-started-with-Machine-Learning",
  "sql-for-data-science",
  "deployment-with-streamlit",
  "transforming-data-through-nlp",
  "mastering-tableau-techniques",
  "elevate-your-productivity-with-excel",
  "image-processing-with-python",
  "data-science-libraries",
  "exploring-linear-algebra-for-data-science",
  "foundations-of-statistical-analysis",
  "applied-deep-learning",
  "aptitude-and-reasoning",
  "bootstrap-basics",
  "python-essentials",
  "master-android-development-with-kotlin",
  "resume-building",
  "js-fundamental-for-beginners",
  "js-advanced-for-beginner",
  "html-fundamentals",
  "css-basic-to-advance",
  "master-reactjs-essentials",
  "frontend-projects",
  "Foundations-Java-Programming",
  "mastering-java-collections",
  "master-c-programming",
  "Master-SDE-Theory",
  "navigating-aws-cloud-practitioner-certification-course",
  "advanced-system-design-and-architecture",
  "linux-mastery-from-basics-to-advanced",
  "github-mastery-from-beginner-to-advanced",
]);

const coursesWhereLabelToBeDisplayed = []; //course ids

class PaymentsPage extends Component {
  constructor(props) {
    super(props);

    this.addToCartRef = React.createRef();
    this.timeLeftRef = React.createRef(null);
    this.salesCurrentTimeRef = null;
    this.salesEndTimeRef = null;

    this.state = {
      isLoaded: false,
      isBatchSelected: false,
      hasRegistered: false,
      batchID: undefined,
      batchSlug: undefined,
      course_name: "",
      course_id: "",
      course_type: undefined,
      has_doubt_assistance: false,
      doubt_assistance_fee: 0,
      selectedBatchName: "",
      selectedBatchStartDate: "",
      first_batch: {},
      right_section: {},
      showInviteCodeBlock: false,
      is_kids_course: false,
      paymentCheckoutImage: "",
      isDoubtSupportButtonClicked: false,
      isDoubtSupportAdded: false,
      errorPage: false,
      courseDescriptionData: undefined,
      showPlacementAssistanceBanner: 0,
      coupon: undefined,
      salesData: null,
      urgencyData: null,
      timerData: null,
      salesApiCalled: false,
      courseDetailsApiCalled: false,
      paymentsFetchApiCalled: false,
      course_fee_type: null,
      salesText: "",
      showTimer: false,
      addOns: [],
      autoRegistrationAllowed: false,
      courseDuration: "",
      graduationYear: null,
      questionnaireApiCalled: false,
      surveyApplicationStatus: null,
      addOnsDefaultThumbnail: "",
      userDetails: null,
      isLoggedIn: null,
      isPremiumUser: false,
      isShowPremiumUpgradeBanner: false,
      isIndianUser: true,
      isCourseEligibleForSale: false,
      isThreeNinetyActive: false,

      // common states between UpcomingBatches and FillDetails
      upcomingBatches: null,
      selectedBatch: null,
      hasUpcomingBatchesData: false,
      fetchingBatchesData: false,
      has_ibm_certification: false,
      ibm_certification_details: null,
      promotionalUpcomingEvents: {}
    };
  }

  async fetchUserBatchData() {
    await axiosLatest
      .get(`/courses/${this.props.match.params.course_slug}/details/`)
      .then((res) => {
        if (res?.data?.total_upcoming_batches === 1) {
          let action = res?.data?.right_section?.register_btn?.action;
          let subAction = res?.data?.right_section?.register_btn?.sub_action;
          let hasRegistered =
            action === "user_already_registered_in_batch" &&
            subAction === "pay_fee";
          let isBatchSelected =
            action === "registration_open" && subAction === "sign_up_now";
          let data = {
            batch_id: res.data.first_upcoming_batch.batch_id,
            batch_name: res.data.first_upcoming_batch.batch_name,
            start_date: res.data.first_upcoming_batch.reg_start_date,
            batch_slug: res.data.first_upcoming_batch.batch_slug,
            show_invite_code_block:
              res.data.first_upcoming_batch.show_invite_code_block,
          };
          if (hasRegistered || this.state.autoRegistrationAllowed)
            this.handleRegisteredUser(data);
          else if (isBatchSelected) this.handleToUpdate(data);
        }
        this.setState((prevState) => ({
          courseDescriptionData: {
            ...prevState.courseDescriptionData,
            profile_image:
              res.data.mentors && res.data.mentors.length
                ? res.data.mentors[0].profile_image
                : res.data.mentors_icon,
            instructor_name:
              res.data.mentors && res.data.mentors.length
                ? res.data.mentors[0].mentor
                : "",
            mentor_description:
              res.data.mentors && res.data.mentors.length
                ? res.data.mentors[0].mentor_description
                : "",
            mentor_bio:
              res.data.mentors && res.data.mentors.length
                ? res.data.mentors[0].mentor_bio
                : "",
            courseRating: res.data.right_section.ratings.avg_rating,
          },
          upcomingBatchesData: res.data.upcoming_batches,
          totalUpcomingBatches: res?.data?.total_upcoming_batches,
          first_batch: res.data.first_upcoming_batch,
          showInviteCodeBlock:
            res.data.first_upcoming_batch.show_invite_code_block,
          right_section: res.data.right_section,
          doubt_assistance_fee: this.state.has_doubt_assistance
            ? res.data.doubt_assistance_price
            : 0,
          currency: res.data.payment_currency_symbol,
          isLoaded: true,
          coupon: res.data.coupon,
          isLoggedIn: res.data.is_logged_in,
          isPremiumUser: res?.data?.can_access_as_premium_user,
          isShowPremiumUpgradeBanner: res?.data?.show_premium_upgrade_banner,
          isCourseEligibleForSale: res.data.is_course_eligible_for_sale,
          isThreeNinetyActive: res?.data?.three_90_info?.is_active,
          isIndianUser: res?.data?.is_indian_user,
          has_ibm_certification: res?.data?.is_user_eligible_for_external_cert,
          ibm_certification_details: res?.data?.external_certification_details,
        }));
      })
      .catch((err) => {
        sendRequestToLogging(
          JSON.stringify({
            traceback:
              "error = " +
              err +
              " \n URL = " +
              window.location.href +
              "\ntraceback: \n" +
              err.stack,
          })
        );
        if (err.response && err.response.status === 404)
          this.setState({ errorPage: true });
      });
  }

  async fetchUserDetails() {
    await axios
      .get("/user/details/")
      .then((res) => {
        this.setState({ userDetails: res?.data?.results });
      })
      .catch((err) => {
        // if user if logged out, don't show error message
        if (err?.response?.status !== 403)
          alert("Couldn't fetch user details.");
      });
  }

  async fetchPromotionalData(){
    await axios
      .get("/events/promotional/" , {
            params: {
              page_source: "payments",
              user_country_code: "IN",
            },
          })
      .then((res) => {
        this.setState({ promotionalUpcomingEvents: res?.data?.upcoming_events});
      })
      .catch((err) => {
          alert("Couldn't fetch promotional details");
      });
  }

  async componentDidMount() {
    this.fetchUserDetails();
    this.fetchPromotionalData();
    await axiosWC
      .get(`courses/${this.props.match.params.course_slug}/`)
      .then((res) => {
        let currentTime = res?.headers?.["x-date"];
        currentTime = currentTime ? new Date(currentTime) : new Date();
        let startTime = new Date(res.data.urgency_start_time);
        let endTime = new Date(res.data.urgency_end_time);
        this.salesCurrentTimeRef = currentTime.getTime();
        if (res.data.urgency_start_time && res.data.urgency_end_time) {
          if (currentTime > startTime && currentTime < endTime) {
            this.setState({
              urgencyData: {
                startTime,
                endTime,
              },
              salesText: "Batch Starts In",
            });
            this.salesEndTimeRef = endTime.getTime();
          }
        }
        this.setState({
          courseDetailsApiCalled: true,
        });
        this.setState(
          {
            courseDescriptionData: {
              course_name: res.data.course_name,
              content: res.data.short_description,
              what_you_will_learn: res.data.what_you_will_learn,
              courseType:
                res.data.course_type === 2
                  ? "Live Course"
                  : res.data.course_type === 1
                  ? "Online Course"
                  : "Offline Course",
            },
            isBatchSelected: this.props.match.params.batchID ? true : false,
            batchID: this.props.match.params.batchID
              ? this.props.match.params.batchID
              : undefined,
            course_name: res.data.course_name,
            course_id: res.data.course_id,
            course_type: res.data.course_type,
            course_duration: res.data.course_duration,
            course_fee_type: res.data.course_fee_type,
            isIntroVideo: res.data.intro_video_id === null ? false : true,
            intro_video_link: res.data.intro_video_link,
            has_doubt_assistance: res.data.has_doubt_assistance,
            doubt_support_expiry_date: res.data.doubt_support_expiry_date
              ? res.data.doubt_support_expiry_date
              : "",
            paymentCheckoutImage: res.data.payment_checkout_image,
            adEventId: res.data.ad_event_id,
            is_kids_course: res.data.is_kids_course,
            showPlacementAssistanceBanner:
              res.data.show_placement_assistance_banner,
            // for self-paced courses only.
            // since both batch selection and reg. form components are merged on a single page, in case of offline and live,
            // user should get to select the batch first.
            autoRegistrationAllowed:
              res.data.auto_registration === 1 && res.data.course_type === 1,
            addOnsDefaultThumbnail: res?.data?.default_feature_thumbnail,
          },
          () => {
            this.fetchUserBatchData();
          }
        );
      })
      .catch((err) => {
        sendRequestToLogging(
          JSON.stringify({
            traceback:
              "error = " +
              err +
              " \n URL = " +
              window.location.href +
              "\ntraceback: \n" +
              err.stack,
          })
        );
        if (err.response && err.response.status === 404)
          this.setState({ errorPage: true });
      });
    axiosWC.get(`sale/active`).then((res) => {
      this.setState({
        salesData: res.data,
        salesApiCalled: true,
      });
    });
    if (this.props.location.state) {
      this.setState({
        isBatchSelected: this.props.location.state.isBatchSelected
          ? true
          : this.state.isBatchSelected,
        batchID: this.props.location.state.batchID
          ? this.props.location.state.batchID
          : this.state.batchID,
        batchSlug: this.props.location.state.batchSlug
          ? this.props.location.state.batchSlug
          : this.state.batchSlug,
        selectedBatchName: this.props.location.state.selectedBatchName
          ? this.props.location.state.selectedBatchName
          : this.state.selectedBatchName,
        selectedBatchStartDate: this.props.location.state.selectedBatchStartDate
          ? this.props.location.state.selectedBatchStartDate
          : this.state.selectedBatchStartDate,
        hasRegistered: this.props.location.state.hasRegistered
          ? this.props.location.state.hasRegistered
          : this.state.hasRegistered,
        showInviteCodeBlock: this.props.location.state.showInviteCodeBlock,
        warningMessage: this.props.location.state.warningMessage,
      });
    }
    if (
      this.props.match.params.course_slug === "dsa-to-development-coding-guide"
    ) {
      await axios.get(`survey-response/`).then((res) => {
        this.setState({
          surveyApplicationStatus: res.data.application_status,
          questionnaireApiCalled: true,
        });
      });
    }



    const searchedQueryParams = getUrlSearchParams(window.location.search, [
      "has_register",
      "batch_slug",
    ]);

    if (
      searchedQueryParams?.has_register == "true" &&
      searchedQueryParams?.batch_slug
    )
      this.handleFillDetailsUpdate();
  }

  componentDidUpdate(prevProps, prevState) {
    const { autoRegistrationAllowed, batchSlug, course_fee_type } = this.state;
    if (autoRegistrationAllowed && course_fee_type === 0 && batchSlug) {
      window.location.href = `/batch/${batchSlug}`;
    }
    if (prevState.courseDetailsApiCalled !== this.state.courseDetailsApiCalled)
      this.startTimerHelper();
    else if (prevState.salesApiCalled !== this.state.salesApiCalled)
      this.startTimerHelper();
  }

  getCourseTypeKey() {
    switch (this.state.courseDescriptionData.courseType) {
      case "Live Course":
        return 2;
      case "Online Course":
        return 1;
      case "Offline Course":
        return 0;
      default:
        break;
    }
  }

  paymentsPageSetState(data) {
    this.setState(data);
  }

  startTimerHelper() {
    if (this.state.salesApiCalled && this.state.courseDetailsApiCalled) {
      if (SALE_ACTIVE) {
        this.salesHandler();
        let saleStartTime = new Date(SALE_START_DATE).getTime();
        let saleEndTime = new Date(SALE_END_DATE).getTime();
        if (
          !this.salesEndTimeRef &&
          this.salesCurrentTimeRef > saleStartTime &&
          this.salesCurrentTimeRef < saleEndTime &&
          Math.abs(new Date(saleEndTime) - new Date(this.salesCurrentTimeRef)) <
            24 * 60 * 60 * 1000
        ) {
          this.salesEndTimeRef = saleEndTime;
          this.setState({
            salesText: "Sale Ends in",
          });
        }
      }
      // if(this.state.salesData?.is_sale_active){
      //     let saleStartTime =  new Date(this.state.salesData.start_time).getTime()
      //     let saleEndTime =  new Date(this.state.salesData.end_time).getTime()
      //     if(!this.salesEndTimeRef && this.salesCurrentTimeRef > saleStartTime && this.salesCurrentTimeRef < saleEndTime){
      //         this.salesEndTimeRef =  saleEndTime
      //         this.setState({
      //             salesText:"Sale Ends in"
      //         })
      //     }
      // }
      //   this.startTimer();
    }
  }

  // startTimer() {
  //     let timerRef = setInterval( () => {
  //         let distance = this.salesEndTimeRef - this.salesCurrentTimeRef;
  //         let days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //         let hours = Math.floor(
  //           (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  //         );
  //         let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //         let seconds = Math.floor((distance % (1000 * 60)) / 1000);
  //         if (distance < 0) {
  //           clearInterval(timerRef);
  //           this.setState({
  //               salesTimerData:null
  //           })
  //         } else {
  //           this.setState({
  //               salesTimerData:{
  //                   days,
  //                   hours,
  //                   minutes,
  //                   seconds,
  //               }
  //           })
  //           this.salesCurrentTimeRef = this.salesCurrentTimeRef + 1000;
  //         }
  //       }, 1000);
  //   };

  addOnsHandler = (addOns) => {
    this.setState({ addOns: addOns, paymentsFetchApiCalled: true });

    if (!this.state.salesText && addOns.length > 0) {
      this.setState({
        salesText: "Offer ends in",
      });
    }
  };

  salesHandler = () => {
    this.setState({ showTimer: false });
  };

  discountPercent(normalPrice, discountedPrice) {
    return Math.round(((normalPrice - discountedPrice) / normalPrice) * 100);
  }

  convertToGrouping(data) {
    return String(data).padStart(2, "0");
  }

  handleToUpdate(data) {
    this.setState({
      isBatchSelected: data.batch_id ? true : false,
      batchID: data.batch_id ? data.batch_id : undefined,
      selectedBatchStartDate: data.start_date
        ? data.start_date.split("T")[0]
        : "",
      showInviteCodeBlock: data.show_invite_code_block,
      batchSlug: data.batch_slug,
      selectedBatchName: data.batch_name,
      warningMessage: data.warning_message,
    });
  }

  handleFillDetailsUpdate(data) {
    this.setState({ hasRegistered: true });
  }

  handleRegisteredUser(record) {
    this.handleToUpdate(record);
    this.handleFillDetailsUpdate(record);
  }
  getRegistrationButton() {
    var action = this.state.right_section.register_btn.action;
    var sub_action = this.state.right_section.register_btn.sub_action;
    var button;
    var data = this.state.right_section.register_btn;
    var record = {
      batch_id: this.state.first_batch.batch_id,
      batch_name: this.state.first_batch.batch_name,
      start_date: this.state.first_batch.reg_start_date,
      batch_slug: this.state.first_batch.batch_slug,
      show_invite_code_block: this.state.first_batch.show_invite_code_block,
    };

    if (action === "user_already_registered_in_batch") {
      if (sub_action === "show_tracks")
        button = (
          <a
            href={this.state.right_section.register_btn.extra.batch_url}
            className="btn btn-success btn-sm"
          >
            Start Course
          </a>
        );
      else if (sub_action === "fee_paid_batch_not_started")
        button = (
          <button disabled className="btn btn-success btn-sm">
            Batch not Started
          </button>
        );
      else if (sub_action === "subscribed")
        button = (
          <div>
            <button
              onClick={() => {
                gtagHelperFunction(
                  "click",
                  "course_payfee_top",
                  window.location.href
                );
                this.handleRegisteredUser(record);
                setInitiatePayment();
              }}
              className="btn btn-success btn-sm mt-2"
            >
              {/* Avail 90% Refund */}
              Pay Fee
            </button>
            <p className="mb-0">
              <small className="text-secondary">Fee Pending</small>
            </p>
          </div>
        );
      else if (sub_action === "pay_fee")
        button = (
          <div>
            <button
              onClick={() => {
                gtagHelperFunction(
                  "click",
                  "course_payfee_top",
                  window.location.href
                );
                this.handleRegisteredUser(record);
                setInitiatePayment();
              }}
              className="btn btn-success btn-sm mt-2"
            >
              {/* Avail 90% Refund
               */}
              Pay Fee
            </button>
            <p className="mb-0">
              <small className="text-secondary">Fee Pending</small>
            </p>
          </div>
        );
      else if (sub_action === "attend_contest")
        button = (
          <a href={data.extra.contest_url} className="btn btn-info btn-sm">
            Attend Contest
          </a>
        );
      else if (sub_action === "payment_link_will_open_on")
        button = (
          <button disabled className="btn btn-dark btn-sm">
            Payment Link opens on {data.extra.payment_start_date.split("T")[0]}
          </button>
        );
      else if (sub_action === "payment_link_closed")
        button = (
          <button disabled className="btn btn-danger btn-sm">
            Payment Link Closed
          </button>
        );
      else if (sub_action === "no_seats_available")
        button = (
          <button disabled className="btn btn-danger btn-sm">
            Seats not available
          </button>
        );
      else if (sub_action === "registration_closed")
        button = (
          <button disabled className="btn btn-danger btn-sm">
            Registration Closed
          </button>
        );
    } else if (action === "registration_not_started") {
      button = (
        <button disabled className="btn btn-dark btn-sm">
          Registration starts on {data.extra.reg_start_date.split("T")[0]}
        </button>
      );
    } else if (action === "registration_closed") {
      button = (
        <button disabled className="btn btn-danger btn-sm">
          Registration Closed
        </button>
      );
    } else if (action === "registration_open") {
      if (sub_action === "subscribe")
        button = (
          <button
            onClick={() => this.handleToUpdate(record)}
            disabled
            className="btn btn-dark btn-sm"
          >
            Subscribe
          </button>
        );
      else if (sub_action === "sign_up_now")
        button = (
          <button
            onClick={() => {
              gtagHelperFunction(
                "click",
                "course_signup_top",
                window.location.href
              );
              this.handleToUpdate(record);
            }}
            className="btn btn-dark btn-sm"
          >
            Sign-Up Now
          </button>
        );
      else if (sub_action === "login_to_subscribe")
        button = (
          <a
            href={`${window.location.href}?loginMode=${record.batch_id}`}
            className="btn btn-success login-modal-btn btn-sm"
          >
            Login to Subscribe
          </a>
        );
      else if (sub_action === "login_to_register")
        button = (
          <a
            href={`${window.location.href}?loginMode=${record.batch_id}`}
            className="btn btn-success login-modal-btn btn-sm"
            onClick={() =>
              gtagHelperFunction(
                "click",
                "course_loginreg_top",
                window.location.href
              )
            }
          >
            Login to Register
          </a>
        );
      else if (sub_action === "registration_closed")
        button = (
          <button disabled className="btn btn-danger btn-sm">
            Registration Closed
          </button>
        );
      else if (sub_action === "free_course")
        button = (
          <button
            onClick={() => {
              gtagHelperFunction(
                "click",
                "course_reg_top",
                window.location.href
              );
              this.handleToUpdate(record);
            }}
            className="btn btn-dark btn-sm"
          >
            Register Now
          </button>
        );
    }
    return button;
  }

  fetchBatches() {
    if (
      this.state.course_type === 1 &&
      this.state.first_batch &&
      Object.keys(this.state.first_batch).length === 0
    ) {
      return (
        <div>
          {" "}
          <h2 className="font-weight-bold text-left">No Active Batch</h2>{" "}
        </div>
      );
    } else {
      return (
        <>
          <UpcomingBatchesComponent
            handleFillDetailsUpdate={this.handleFillDetailsUpdate.bind(this)}
            handleUpdate={this.handleToUpdate.bind(this)}
            paymentsPageSetState={this.paymentsPageSetState.bind(this)}
            upcomingBatches={this.state.upcomingBatches}
            hasUpcomingBatchesData={this.state.hasUpcomingBatchesData}
            currency={this.state.currency}
            selfPacedCourseUpcomingBatchData={{
              ...this.state.first_batch,
              ...this.state.right_section,
            }}
            paymentsPageFlag={true}
            courseSlug={this.props.match.params.course_slug}
            courseId={this.state.course_id}
            selectedBatch={this.state.batchID}
            courseType={this.getCourseTypeKey()}
            courseFeeType={this.state.course_fee_type}
            isLoggedIn={this.state.isLoggedIn}
            fetchingBatchesData={this.state.fetchingBatchesData}
            setFetchingBatchesData={(val) =>
              this.setState({ fetchingBatchesData: val })
            }
            isCourseEligibleForSale={this.state?.isCourseEligibleForSale}
            isIndianUser={this.state?.isIndianUser}
            isHidden={this.state.totalUpcomingBatches === 1}
          />
          <PhonePePaymentComponent />
        </>
      );
    }
  }

  handleBackToBatch() {
    this.setState({
      hasRegistered: false,
      isBatchSelected: false,
    });
  }

  fetchRightSection() {
    const isThreeNinetyExempted =
      exemptedThreeNinetyPromotionForCourses.has(
        this.props.match.params.course_slug
      ) || this.state.course_fee_type === 0;

    if (!this.state.isLoaded) {
      return (
        <div className="payments_page_loader">
          <div>
            <img
              src="https://media.geeksforgeeks.org/img-practice/prod/generic/1/Web/Content/gfg_loader_1707204855.gif"
              alt="gfg_loader"
            />
          </div>
          <div>
            <span>Collecting your batch status...</span>
          </div>
        </div>
      );
    } else if (
      this.state.hasRegistered ||
      (this.state.course_fee_type === 1 &&
        this.state.autoRegistrationAllowed &&
        this.state.isBatchSelected)
    )
      return (
        <OrderSummaryComponent
          data={{
            courseName: this.state.course_name,
            intro_video_id: this.state.isIntroVideo,
            intro_video_link: this.state.intro_video_link,
            selectedBatchStartDate: this.state.selectedBatchStartDate,
            course_id: this.state.course_id,
            has_doubt_assistance: this.state.has_doubt_assistance,
            doubt_support_expiry_date: this.state.doubt_support_expiry_date,
            doubt_assistance_fee: this.state.doubt_assistance_fee,
            currency: this.state.currency,
            courseSlug: this.props.match.params.course_slug,
            paymentCheckoutImage: this.state.paymentCheckoutImage,
            course_type: this.state.course_type,
            courseFeeType: this.state.course_fee_type,
            batchSlug:
              this.state.batchSlug ??
              getUrlSearchParams(window.location.search, ["batch_slug"])
                ?.batch_slug,
            batchName: this.state.selectedBatchName,
            warningMessage: this.state.warningMessage,
            courseDuration: this.state.course_duration,
            addOnsDefaultThumbnail: this?.state?.addOnsDefaultThumbnail,
            userEmail: this?.state?.userDetails?.email,
            userPhoneNumber: this?.state?.userDetails?.phone,
            userCountryCallingCode:
              this?.state?.userDetails?.country_calling_code,
            userCountryCode: this?.state?.userDetails?.country || "India",
            hasIbmCertification: this?.state?.has_ibm_certification,
            ibmCertificationDetails: this?.state?.ibm_certification_details,
          }}
          isCourseEligibleForSale={this.state?.isCourseEligibleForSale}
          isIndianUser={this.state?.isIndianUser}
          backToBatch={this.handleBackToBatch.bind(this)}
          courseSlug={this.props.match.params.course_slug}
          addToCartRef={this.addToCartRef}
          toggleDoubtSupportButton={this.toggleDoubtSupportButton.bind(this)}
          toggleDoubtSupport={this.toggleDoubtSupport.bind(this)}
          isDoubtSupportButtonClicked={this.state.isDoubtSupportButtonClicked}
          isDoubtSupportAdded={this.state.isDoubtSupportAdded}
          showPlacementAssistanceBanner={
            this.state.showPlacementAssistanceBanner
          }
          coupon={this.state.coupon}
          courseId={this.state.course_id}
          addOnsHandler={this.addOnsHandler}
          batchId={
            this?.props?.location?.state?.batchID
              ? this?.props?.location?.state?.batchID
              : this?.state?.batchID
          }
          isThreeNinetyExempted={isThreeNinetyExempted}
          isThreeNinetyActive={this.state.isThreeNinetyActive}
          isPremiumUser={this.state.isPremiumUser}
          isShowPremiumUpgradeBanner={this.state.isShowPremiumUpgradeBanner}
          promotionalUpcomingEvents={this.state.promotionalUpcomingEvents}
        />
      );
    else {
      var fillDetailsData = {
        batchID: this.state.batchID,
        batchSlug: this.state.batchSlug,
        batchName: this.state.selectedBatchName,
        batchStartDate: this.state.first_batch?.start_date,
        courseName: this.state.course_name,
        showInviteCodeBlock: this.state.showInviteCodeBlock,
        course_type: this.state.course_type,
        courseFeeType: this.state.course_fee_type
      };

      const isUpcomingBatchesContainerHidden =
        this.state.totalUpcomingBatches === 1;

      return (
        <div
          className={`registration_page_container_v2 ${
            isUpcomingBatchesContainerHidden
              ? "is_upcoming_batches_container_hidden"
              : ""
          }`}
        >
          {/* {(this.state.isBatchSelected && */}
          {this.state?.upcomingBatches?.length ||
          this.state.fetchingBatchesData ? (
            <FillDetailsComponent
              handleFillDetailsUpdate={this.handleFillDetailsUpdate.bind(this)}
              handleToUpdate={this.handleToUpdate.bind(this)}
              handleSelfPacedCourseRegisteredUser={this.handleRegisteredUser.bind(
                this
              )}
              updateUserDetailsState={({ name, value }) => {
                this.setState((prevState) => ({
                  ...prevState,
                  userDetails: {
                    ...(prevState?.userDetails ?? {}),
                    [name]: value,
                  },
                }));
              }}
              userDetails={this.state.userDetails}
              paymentsPageSetState={this.paymentsPageSetState.bind(this)}
              setGraduationYear={this.setGraduationYear.bind(this)}
              data={fillDetailsData}
              backToBatch={this.handleBackToBatch.bind(this)}
              courseSlug={this.props.match.params.course_slug}
              adEventId={this.state.adEventId}
              is_kids_course={this.state.is_kids_course}
              warningMessage={this.state.warningMessage}
              upcomingBatches={this.state.upcomingBatches}
              courseId={this.state.course_id}
              isUpcomingBatchesContainerHidden={
                isUpcomingBatchesContainerHidden
              }
              isLoggedIn={this.state.isLoggedIn}
              isThreeNinetyExempted={isThreeNinetyExempted}
              isThreeNinetyActive={this.state.isThreeNinetyActive}
              isCourseEligibleForSale={this.state?.isCourseEligibleForSale}
              isIndianUser={this.state?.isIndianUser}
              isUsersGitHubAccount={this.state.userDetails?.email === "EMPTY"}
              promotionalUpcomingEvents={this.state.promotionalUpcomingEvents}
            />
          ) : null}
          {this.fetchBatches()}
        </div>
      );
    }
  }

  fetchLeftSection() {
    if (this.state.hasRegistered && this.state.has_doubt_assistance)
      return (
        <DoubtAssistanceComponent
          addToCartRef={this.addToCartRef}
          isDoubtSupportButtonClicked={this.state.isDoubtSupportButtonClicked}
          isDoubtSupportAdded={this.state.isDoubtSupportAdded}
          doubtSupportPrice={this.state.doubt_assistance_fee}
        />
      );
    else
      return <DescriptionComponent data={this.state.courseDescriptionData} />;
  }

  toggleDoubtSupportButton() {
    this.setState((prevState) => {
      return {
        ...prevState,
        isDoubtSupportButtonClicked: !prevState.isDoubtSupportButtonClicked,
      };
    });
  }

  toggleDoubtSupport(value) {
    this.setState({
      isDoubtSupportAdded: value,
    });
  }
  setGraduationYear(graduationYear) {
    this.setState({
      graduationYear,
    });
  }
  render() {
    if (
      this.props.match.params.course_slug === "dsa-to-development-coding-guide"
    ) {
      if (!this.state.questionnaireApiCalled)
        return (
          <div style={{ marginTop: "100px" }}>
            <span className="text-secondary font-weight-bold">
              Collecting your batch status loading
            </span>
            <div class="jumping-dots-loader">
              <span></span> <span></span> <span></span>{" "}
            </div>
          </div>
        );
      else {
        if (this.state.surveyApplicationStatus !== 3) {
          window.location.href =
            "https://practice.geeksforgeeks.org/courses/dsa-to-development-coding-guide";
        }
      }
    }
    if (this.state.errorPage) return <ErrorComponent />;
    else {
      return (
        <section>
          <div className="row scrollbar-setting">
            {/* <div id = "leftSection" className = "col-lg-4 d-none d-lg-block">
                            <div className = "custom-margin-for-header">
                                {this.fetchLeftSection()}
                            </div>
                        </div> */}
            <div
              id="rightSection"
              className={`col-12 pr-0 paymentsSection ${
                this.state.isThreeNinetyActive ? "three_90_sales_bg_img" : ""
              }`}
            >
              <div
                className={`payments_container ${
                  this.state.totalUpcomingBatches === 1 ? "container_sm" : ""
                }`}
              >
                {/* <PaymentProgress data = {
                                        {
                                        "isBatchSelected":this.state.isBatchSelected,
                                        "hasRegistered" : this.state.hasRegistered || (this.state.course_fee_type === 1 && this.state.autoRegistrationAllowed && this.state.isBatchSelected),
                                        "course_type":this.state.course_type,
                                        }
                                    }
                                    backToBatch={this.handleBackToBatch.bind(this)}
                                /> */}
                <>
                  {(
                    this.props.match?.params?.course_slug ?? ""
                  ).toLowerCase() === "dsa-self-paced" &&
                  this.state.graduationYear !== null &&
                  this.state.graduationYear <= 2022 &&
                  this.state.hasRegistered ? (
                    <div className="payment_page_static_banner">
                      <a href="/courses/geeks-classes-live" target="_blank">
                        <img
                          className="payment_page_static_banner__desktop"
                          src="https://media.geeksforgeeks.org/img-practice/pymt_pg_banner_wp-1687167127.png"
                          alt="payment_page_desktop_banner"
                        />
                        <img
                          className="payment_page_static_banner__mobile"
                          src="https://media.geeksforgeeks.org/img-practice/pymt_pg_mobile_banner_wp-1687179101.png"
                          alt="payment_page_mobile_banner"
                        />
                      </a>
                    </div>
                  ) : null}

                  {/* also add a check to see if the payments fetch Api is called */}
                  <div
                    className="sales_timer"
                    style={{
                      display:
                        this.state.showTimer ||
                        coursesWhereLabelToBeDisplayed.includes(
                          this.state.course_id
                        )
                          ? "flex"
                          : "none",
                    }}
                  >
                    <strong>Limited Time Offer!</strong>
                    {this.state.salesText &&
                      this.state.courseDetailsApiCalled &&
                      this.state.salesApiCalled &&
                      this.state.paymentsFetchApiCalled &&
                      this.state.course_fee_type !== 0 && (
                        <div>
                          <strong className="timer_desc">
                            {this.state.salesText}
                          </strong>
                          <SalesTimer
                            urgencyStartTime={
                              this.state?.urgencyData?.startTime
                            }
                            urgencyEndTime={this.state?.urgencyData?.endTime}
                            services={this.state?.addOns}
                            seperatorStyle={{
                              color: "rgba(0, 0, 0, 0.6)",
                            }}
                            boxStyle={{
                              background: "#FED35C",
                              color: "rgba(0, 0, 0, 0.6)",
                            }}
                            handler={this.salesHandler}
                          />
                        </div>
                      )}
                  </div>
                </>
                {/* {this.state.salesApiCalled && this.state.salesData?.is_sale_active &&
                                   !courseExcludedFromSale.includes(this.state.course_id) && 
                                   this.state.course_fee_type !== 0 && <>
                                    <div className='sales_timer'>
                                        <div><strong>Reset and Restart with Resolution Days 2023!</strong></div>
                                        <div><strong>Limited time offer!</strong></div> 
                                    </div>
                                </>} */}
                {this.fetchRightSection()}
              </div>
            </div>
          </div>
        </section>
      );
    }
  }
}

export default PaymentsPage;
